import { render, staticRenderFns } from "./FollowRequests.vue?vue&type=template&id=2902b146&"
import script from "./FollowRequests.vue?vue&type=script&lang=js&"
export * from "./FollowRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports